import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import Brand from './components/Brand';
import NavbarComponent from './components/NavbarComponent';

ReactDOM.render(
  <BrowserRouter>
    <div className="Top">
      <Brand />
    </div>
    <div className="Header">
      <NavbarComponent />
      <div className="Separation" />
    </div>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
